/**
 * The shell every peripheral surface sits in — and the thing that keeps them from each
 * being a slightly different page.
 *
 * One column at the reading measure, one `h1`, an optional way back. It replaces
 * `routes/Scaffolded.tsx`, which said "Scaffold only" on three routes and is deleted
 * with this stage.
 *
 * The measure is the same `--measure` the story feed reads. A settings form does not need a
 * 34rem line length, but a player moving between the two should not feel the page change
 * width underneath them, and the peripheral surfaces are the ones that would otherwise each
 * pick their own.
 */
import type { ReactNode } from 'react';
import { Link } from 'react-router';

interface PageProps {
  title: string;
  /** Where "back" goes, and what it is called. Omitted on a page that is itself the hub. */
  back?: { to: string; label: string };
  children: ReactNode;
}

export function Page({ title, back, children }: PageProps) {
  return (
    <main className="mx-auto flex min-h-dvh w-full max-w-[var(--measure)] flex-col gap-6 px-5 py-10">
      {back ? (
        <Link
          to={back.to}
          className="text-fg-faint hover:text-accent font-mono transition-colors"
          style={{ fontSize: 'var(--text-meta)' }}
        >
          ← {back.label}
        </Link>
      ) : null}

      <h1 className="text-fg text-2xl font-semibold tracking-tight">{title}</h1>

      {children}
    </main>
  );
}
